import {arrowDownCircleSvg as Icon__small__arrowDownCircleSvg} from '../Icon__small/Icon__small--arrowDownCircle.js'

export var arrowDownCircle = {
  name: 'arrowDownCircle',
  category: 'icon',
  colorable: true,
  svg: Icon__small__arrowDownCircleSvg,
};
